import axios from "axios";
import { API_BASE } from "../constants/config";

export const getSettings = async (folder) => {
  try {
    const response = await axios.get(
      `https://online.bleepshare.com/public/api/user/v4/ftp/setting?folder=${folder}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching settings:", error);
    throw error;
  }
};

export const getGalleryPage = async (page, folder) => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/fs-events-data?page=${page}&username=${folder}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching gallery page:", error);
    throw error;
  }
};

export const buildFileUR = async (row) => {
  try {
    const response = await axios.get(
      `${API_BASE}/api/fs-load-image?token=${encodeURIComponent(row.username)}&image=${encodeURIComponent(row.file)}`,
    );
    return response;
  } catch (error) {
    console.error("Error building file URL:", error);
    throw error;
  }
};

export const fileURL = (row) => {
  return `${API_BASE}/api/fs-load-image?token=${encodeURIComponent(row.username)}&image=${encodeURIComponent(row.file)}`;
};
export const sendMessage = async (data) => {
  try {
    const form = new URLSearchParams(data);

    const response = await axios.post(`${API_BASE}/api/v3/sms/send`, form, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        BLEEPKEY: "YOUR_TOKEN_HERE",
        Accept: "application/json",
      },
      withCredentials: false,
    });

    return response;
  } catch (error) {
    // Normalize axios error into a REAL Error object (ESLint safe)
    const status = error?.response?.status ?? 500;
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong. Please try again.";

    const err = new Error(message);
    err.status = status;
    err.raw = error; // optional: keep original axios error for debugging

    throw err; // ✅ this fixes no-throw-literal
  }
};